import { render, staticRenderFns } from "./alertSettingsForm.vue?vue&type=template&id=7540c5a6&scoped=true&"
import script from "./alertSettingsForm.vue?vue&type=script&lang=js&"
export * from "./alertSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./alertSettingsForm.vue?vue&type=style&index=0&id=7540c5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7540c5a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7540c5a6')) {
      api.createRecord('7540c5a6', component.options)
    } else {
      api.reload('7540c5a6', component.options)
    }
    module.hot.accept("./alertSettingsForm.vue?vue&type=template&id=7540c5a6&scoped=true&", function () {
      api.rerender('7540c5a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantBusinessStatusManagement/tracking/alertSettingsForm.vue"
export default component.exports